import o from "react";
/* empty css            */
const a = ({
  children: t
}) => /* @__PURE__ */ o.createElement("div", { className: "rnf-button-group" }, t);
export {
  a as ButtonGroup
};
//# sourceMappingURL=ButtonGroup.mjs.map
